<template>
  <section class="InquiryCondition0007">
    <el-row :gutter="0" class="InquiryConditionHead">
      <router-link to="/sp/0002" class="Router__To__Destination" tabindex="1">
        <i class="el-icon-close" tabindex="1"></i>
      </router-link>
      <el-col :span="6" class="whiteBg">
        <span class="InquiryConditionSpan">原文利実績：照会条件設定</span>
      </el-col>
      <el-col :span="12">
        <img src="../../assets/image/logo-new.png" alt="logo" class="ElnetLogo" />
      </el-col>
      <el-col :span="6"></el-col>
    </el-row>
    <el-row class="InquiryConditionBody">
      <el-form ref="form" :model="form" label-width="auto">
        <el-form-item label="集計条件">
          <span>ユーザグループID group1 (ユーザID：kanri1)</span>
        </el-form-item>
        <el-form-item label="集計期間" class="Aggregation__period">
          <!-- <el-input v-model="form.name"></el-input> -->
          <v-date-picker mode="range" v-model="range" locale="ja" class="SelectDateRangeInq" />
        </el-form-item>
        <router-link to="/sp/0016" class="Router__To__Destination" tabindex="1">
        <el-button type="primary" plain class="inquiry__btn">照会</el-button>
        </router-link>
      </el-form>
    </el-row>
  </section>
</template>

<script>
import Vue from "vue";
import VCalendar from "v-calendar-ie11";
//import Common from '../../common/CommonFunc.js'
Vue.use(VCalendar);
var CurrentYear = new Date().getFullYear();
var CurrentMonth = new Date().getMonth();
var CurrentDay = new Date().getDate();
var FifteendaysBefore = CurrentDay - 15;
export default {
  name: "InquiryCondition0007",
  props: [],
  mounted() {},
  data() {
    return {
      range: {
        //start: new Date(2020, 2, FifteendaysBefore), // Jan 16th, 2018
        start: new Date(CurrentYear, CurrentMonth, FifteendaysBefore), // Jan 16th, 2018
        end: new Date(CurrentYear, CurrentMonth, CurrentDay) // Jan 19th, 2018
      },
      form: {
        name: ""
      }
    };
  },
  methods: {},
  computed: {},
    beforeCreate(){
      //Common.Session.SP_CheckSessionExists_IfExpired_GoToLogout();
      //Common.Session.CheckIsMobile("/sp/0007","/0014"); // MobileScreen Path, WebScreen Path
   }
};
</script>
<style scoped>
 @import "0007.css";
 @import "../../assets/css/customStyle.css"; 
</style>